import * as qs from 'query-string'

export type OAuthConsentQueryParams = {
	oauthRedirect: string
	rememberMe?: string | boolean
	qr?: string | boolean
	qt?: string | boolean
}

export const buildOAuthConsentUrl = (params: OAuthConsentQueryParams): string => `/auth/oauth/consent?${qs.stringify(params)}`
